<template>
    <img src="/images/logo-intimateinteractive-220x50.png" style="width:120px;">
</template>
